import { useEffect, useMemo } from 'react';
import { useAnalysisData } from '../../contexts/AnalysisDataContext';
import { paceCurve } from '../../utils/analytics/pacingMetrics';
import { makeDelta } from '../../utils/analytics/comparison';
import { addDays, getTodayString } from '../../utils/dateUtils';

const HORIZON_WEEKS = 12;

/**
 * Booking pace needs a wide window: the next 12 weeks plus the same period
 * last year (created_at reconstruction). ~15 months of reservations.
 */
export function usePacingAnalysis() {
  const { stays, loading, error, ensureRange } = useAnalysisData();
  const today = getTodayString();

  useEffect(() => {
    ensureRange(addDays(today, -372), addDays(today, HORIZON_WEEKS * 7));
  }, [today, ensureRange]);

  return useMemo(() => {
    const curve = paceCurve(stays, today, HORIZON_WEEKS);
    const next4This = curve.slice(0, 4).reduce((acc, p) => acc + p.thisYear, 0);
    const next4Last = curve.slice(0, 4).reduce((acc, p) => acc + p.lastYear, 0);
    const horizonThis = curve.reduce((acc, p) => acc + p.thisYear, 0);
    const horizonLast = curve.reduce((acc, p) => acc + p.lastYear, 0);

    return {
      loading,
      error,
      curve,
      horizonWeeks: HORIZON_WEEKS,
      next4This,
      next4Last,
      next4Delta: makeDelta(next4This, next4Last),
      horizonThis,
      horizonLast,
      horizonDelta: makeDelta(horizonThis, horizonLast),
    };
  }, [stays, today, loading, error]);
}
